import { House } from '../types/house';

const API_BASE = '/api';

export const api = {
  houses: {
    list: async (): Promise<House[]> => {
      const res = await fetch(`${API_BASE}/houses`);
      if (!res.ok) throw new Error('Failed to fetch houses');
      return res.json();
    },
    create: async (house: House): Promise<void> => {
      const res = await fetch(`${API_BASE}/houses`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(house),
      });
      if (!res.ok) throw new Error('Failed to create house');
    },
    update: async (id: string, updates: Partial<House>): Promise<void> => {
      const res = await fetch(`${API_BASE}/houses/${id}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(updates),
      });
      if (!res.ok) throw new Error('Failed to update house');
    },
    delete: async (id: string): Promise<void> => {
      const res = await fetch(`${API_BASE}/houses/${id}`, {
        method: 'DELETE',
      });
      if (!res.ok) throw new Error('Failed to delete house');
    },
  },
  images: {
    upload: async (id: string, blob: Blob): Promise<void> => {
      const res = await fetch(`${API_BASE}/images/${id}`, {
        method: 'PUT',
        body: blob,
      });
      if (!res.ok) throw new Error('Failed to upload image');
    },
    get: async (id: string): Promise<Blob> => {
      const res = await fetch(`${API_BASE}/images/${id}`);
      if (!res.ok) throw new Error('Failed to fetch image');
      return res.blob();
    },
  },
};
